import { AxiosRequestConfig } from 'axios';
import { api } from 'shared/api';

import { Offer } from './types';

type CommonPayload<T> = T & {
    orderId: string;
    orderRoleId: string;
}

export type AcceptShiftsPayload = CommonPayload<{
    shiftIds: string[];
    offeredShiftIds: string[];
    comment: string | null;
}>;

export type ProcessPeriodOfferPayload = CommonPayload<{
    periodIds: string[];
    offeredPeriodIds: string[];
}>;

export type RejectPayload = CommonPayload<unknown>

export async function acceptShifts(payload: AcceptShiftsPayload) {
    return api.post<AcceptShiftsPayload, void>(`orders/v2/acceptOfferedShifts`, payload);
}

export async function rejectShifts(payload: RejectPayload) {
    return api.post<RejectPayload, void>(`orders/v2/rejectAllShifts`, payload);
}

export async function processPeriodOffer(payload: ProcessPeriodOfferPayload) {
    return api.post<ProcessPeriodOfferPayload, void>(`orders/v2/acceptOfferedPeriods`, payload);
}

export async function rejectWeeks(payload: RejectPayload) {
    return api.post<RejectPayload, void>(`orders/v2/rejectAllPeriods`, payload);
}

export async function fetchOffer(orderId: string, orderRoleId: string) {
    const config: AxiosRequestConfig = {
        params: {
            orderId,
            orderRoleId
        }
    };

    return api.get<Offer>('orders/v2/getCandidateRequestDetails', undefined, config);
}
